import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@components/ui/breadcrumb.tsx'
import { useDynamicBreadcrumbs } from '@hooks/use-dynamic-breadcrumbs.ts'
import { Link, useLocation } from '@tanstack/react-router'
import { capitalizeFirstLetter } from '@utils/helper-functions.tsx'
import localizedPages from '@utils/i18n-to-migrate/pages.no.json'
import { Fragment } from 'react'

type PageKeys = keyof typeof localizedPages

export function AppBreadcrumbs() {
  const location = useLocation()
  const fromSearch = location.state.fromSearch
  const { breadcrumb_routes } = useDynamicBreadcrumbs()
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {breadcrumb_routes.map((crumb) => {
          const isLast = breadcrumb_routes.indexOf(crumb) === breadcrumb_routes.length - 1

          if (isLast) {
            const crumbName = crumb.isDynamic
              ? crumb.name
              : localizedPages[crumb.name as PageKeys] || crumb.name

            return (
              <BreadcrumbItem key={crumb.path}>
                <BreadcrumbPage>{capitalizeFirstLetter(crumbName)}</BreadcrumbPage>
              </BreadcrumbItem>
            )
          }

          const linkText = crumb.isDynamic
            ? crumb.name
            : localizedPages[crumb.name as PageKeys] || crumb.name

          return (
            <Fragment key={`${crumb.path}-frag`}>
              <BreadcrumbItem key={crumb.path} className="hidden md:block">
                <BreadcrumbLink asChild>
                  <Link to={crumb.path} state={{ fromSearch: fromSearch }}>
                    {capitalizeFirstLetter(linkText)}
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="hidden md:block" />
            </Fragment>
          )
        })}
      </BreadcrumbList>
    </Breadcrumb>
  )
}
